<template>
  <transition name="modal-fade">
    <div class="modal-backdrop-new">
      <div
        class="modal-new"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header-new" id="modalTitle">
          <slot name="header">Disclaimer</slot>
          <button type="button" class="btn-close" @click="close" aria-label="Close modal">x</button>
        </header>
        <section class="modal-body-new" id="modalDescription">
          <slot name="body">
            <div>
              <label class="mb-3" style="width: 400px; padding-left:20px">Anand Rathi Share & Stock Brokers Ltd does not provide investment advisory or online portfolio evaluation services. If a client is interested in portfolio evaluation services, they can avail of these services through William O’Neil India Pvt. Ltd. Any discrepancies/disputes will remain between a client & William O’Neil India Pvt. Ltd. Anand Rathi Share & Stock Brokers Ltd will not participate or be a party in any dispute.</label>


            </div>
             <a
                class="alpha-btn"
                style="color: white; cursor: pointer;width: 160px; text-align: center;margin-left:110px;"
                @click="close"
              >Okay</a>
          </slot>
        </section>
      </div>
    </div>
  </transition>
</template>



<script>

export default {
  name: "arDisclaimer",
  props: ["cancelModal", "isBrokerGuest"],
  data() {
    return {
    };
  },

  methods: {
    close() {
      // if (!this.isBrokerGuest) {
        this.$router.replace('/register/')
      // }
      this.cancelModal();

    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dialogs/arDisclaimer.vue